export enum BookingServiceAddBtnStateEnum {
    AddItemBtn = 0,
    AddItemCard = 1
}
